<wm-form-activity-input-view
  [activity]="activity"
  [form]="form"
  [applicationId]="applicationId"
  #formActivityInputView
></wm-form-activity-input-view>

<form method="POST" [formGroup]="form">
  <form method="POST" #paymentForm></form>

  <div class="row">
    <!-- Manual Payment Details -->


            @if(!templateForPermitForm){
                 <div class="col-6">
      <div *ngIf="activity.model.totalDue > 0">
        <form *ngIf="manualForm" [formGroup]="manualForm">
                     <ng-container *ngIf="showManualPayment">
            <div class="form-group">
              <label for="paymentMethod" class="bmd-label-floating">
                Payment Method <span class="text-red">*</span>
              </label>
              <select
                class="form-control"
                [(ngModel)]="activity.model.paymentMethod"
                formControlName="paymentMethod"
                name="paymentMethod"
              >
                <option [ngValue]="2">Credit Card POS</option>
                <option [ngValue]="0">Check</option>
                <option [ngValue]="1">Cash</option>
                <option
                  [ngValue]="3"
                  *ngIf="
                    hasIntegration && (!isTestApplication || isGlobalAdmin)
                  "
                  >Online</option
                >
              </select>
              <wm-control-message
                [control]="manualForm.controls['paymentMethod']"
              ></wm-control-message>
              <div
                *ngIf="activity.model.paymentMethod == '2'"
                class="text-danger"
              >
                Credit Card POS (Point of Sale) should only be used by
                authorized users to manually record a credit card payment that
                was collected outside of GeoPermits.
              </div>
            </div>

             <div class="form-group">
              <label for="transactionNumber" class="bmd-label-floating">
                {{
                  activity.model.paymentMethod == PaymentMethods.Check
                    ? 'Check #'
                    : activity.model.paymentMethod ==
                      PaymentMethods.CreditCardPOS
                    ? 'Confirmation Number'
                    : 'Notes'
                }}
                <span
                  class="text-red"
                  *ngIf="activity.model.paymentMethod == '2'"
                  >*</span
                >
              </label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="activity.model.transactionNumber"
                formControlName="transactionNumber"
                name="transactionNumber"
              />
            </div>
            <wm-control-message
              [control]="manualForm.controls['transactionNumber']"
            ></wm-control-message>

             </ng-container>

                <ng-container *ngIf="hasIntegration || showManualPayment">
            <div
              class="form-group"
              *ngIf="activity.model.allowMultiplePayments"
            >
              <div class="row">
                <div class="col-12 mb-2">
                  Payment Amount <span class="text-red">*</span>
                  <wm-control-message
                    [control]="manualForm.controls['paymentAmountOption']"
                  ></wm-control-message>
                </div>
              </div>
              <div class="row ml-2">
                <div class="col-3 col-sm-3 col-md-4 col-lg-2 col-xl-4">
                  <input
                    type="radio"
                    value="fullAmount"
                    formControlName="paymentAmountOption"
                    [checked]="false"
                    (click)="payFull()"
                  />
                  Total Due
                </div>
                <div
                  class="col-9 col-sm-9 col-md-8 col-lg-10 col-xl-8"
                  [ngClass]="{
                    disabledInActiveDiv: paymentOption !== 'fullAmount'
                  }"
                >
                  {{ activity.model.totalDue | currency }}
                </div>
              </div>
              <div class="row ml-2">
                <div class="col-3 col-sm-3 col-md-4 col-lg-2 col-xl-4">
                  <input
                    type="radio"
                    value="partialAmount"
                    formControlName="paymentAmountOption"
                    [checked]="false"
                    (click)="payPartial()"
                  />
                  Other Amount
                </div>
                <div
                  class="col-9 col-sm-9 col-md-8 col-lg-10 col-xl-8"
                  [ngClass]="{
                    disabledInActiveDiv: paymentOption !== 'partialAmount'
                  }"
                >
                  <input
                    type="number"
                    class="form-control"
                    formControlName="paymentAmount"
                    [(ngModel)]="activity.model.paymentAmount"
                    (focus)="startEditingPartialAmount()"
                  />
                  <div class="small">
                    You will not be able to continue past this step in the
                    process until the fees are paid in full.
                  </div>
                  <wm-control-message
                    [control]="manualForm.controls['paymentAmount']"
                  ></wm-control-message>
                </div>
              </div>
            </div>
            <ng-template #paymentButton>
              <button
                class="btn btn-raised btn-primary"
                [disabled]="
                  processing ||
                  !PaymentMethods[activity.model.paymentMethod] ||
                  viewingAsApplicantInTest
                "
                (click)="submitPayment()"
              >
                <span *ngIf="!processing">Make Payment</span>

                <span *ngIf="processing">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Loading Payment Form...
                </span>
              </button>
            </ng-template>
            <ng-template #forteCheckoutPaymentButton>
              <button
                class="btn btn-raised btn-primary btn-overrides"
                callback="callback"
                [disabled]="
                  processing ||
                  !PaymentMethods[activity.model.paymentMethod] ||
                  viewingAsApplicantInTest ||
                  signing ||
                  manualForm.invalid
                "
                id="fortePaymentButton"
                [attr.api_access_id]="
                  activity.model.paymentButtonParameters.apiAccessId
                "
                method="sale"
                version_number="2.0"
                hash_method="sha256"
                [attr.total_amount]="
                  activity.model.paymentButtonParameters.amount
                "
                [attr.location_id]="
                  activity.model.paymentButtonParameters.locationId
                "
                [attr.utc_time]="activity.model.paymentButtonParameters.utcTime"
                [attr.order_number]="
                  activity.model.paymentButtonParameters.orderNumber
                "
                [attr.signature]="
                  activity.model.paymentButtonParameters.signature
                "
              >
                {{ processing ? 'Processing Payment' : 'Make Payment' }}
              </button>
            </ng-template>
            <ng-container
              *ngIf="activity && activity.model && activity.model.paymentButtonTemplate && this[activity.model.paymentButtonTemplate]"
            >
              <ng-template
                *ngTemplateOutlet="(activity.model.paymentMethod == PaymentMethods.Online ? this[activity.model.paymentButtonTemplate] : this['paymentButton']);"
              ></ng-template>
            </ng-container>
          </ng-container>




            </form>
        <span *ngIf="viewingAsApplicantInTest">
          <i>
            Cannot make an online payment in a test application. Please change
            to an admin role to make a manual payment.
          </i>
        </span>
        <span
          *ngIf="
            isGlobalAdmin &&
            isTestApplication &&
            activity.model.paymentMethod === PaymentMethods.Online
          "
        >
          <i>
            Note: Not all online payment providers are set up to work in a test
            application.
          </i>
        </span>
        <span *ngIf="!hasIntegration && !showManualPayment">
          Please pay in the office
        </span>
      </div>
      <div *ngIf="!(activity.model.totalDue > 0)">
        <i>No fees due.</i>
      </div>
    </div>
    <div class="col-6">
      <div class="card">
        <div class="card-body">
          <h6 class="card-title">Fee Summary</h6>
          <div *ngIf="!lineItems"><i>Loading Fees</i></div>

          <ng-container *ngIf="lineItems">
            <ul class="list-unstyled mt-3">
              <li *ngFor="let fee of lineItems" class="my-2">
                {{ fee.name }}
                <span class="float-right">{{ fee.amount | currency }}</span>
              </li>
            </ul>

            <hr />
          </ng-container>

          <ng-container *ngIf="activity.model.fees">
            <ul class="list-unstyled mt-3">
              <li>
                Total Fees
                <span class="float-right">
                  {{ activity.model.totalFees | currency }}
                </span>
              </li>
            </ul>

            <hr />
          </ng-container>

          <h6 class="mt-4">
            Total Due

            <span class="float-right font-weight-bold">
              {{ activity.model.totalDue | currency }}
            </span>
          </h6>
        </div>
      </div>
      <ng-container
        *ngIf="activity.model.payments && activity.model.payments.length > 0"
      >
        <div class="card mt-4">
          <div class="card-body">
            <h6 class="card-title">
              Payments Made
            </h6>
            <table class="table">
              <thead>
                <tr>
                  <th>Payment Method</th>
                  <th>Paid On</th>
                  <th style="text-align: right">Amount</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let pmt of activity.model.payments">
                  <td>{{ pmt.paymentMethod }}</td>
                  <td>{{ pmt.confirmedOn | date: 'MMMM d, yyyy h:mm a' }}</td>
                  <td align="right">{{ pmt.requestedAmount | currency }}</td>
                  <td>
                    <a
                      [href]="apiBase + '/files/receipt/' + pmt.id"
                      class="btn btn-raised btn-primary float-right"
                      target="_blank"
                      rel="noopener"
                    >
                      View receipt
                    </a>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td align="right" colspan="3">
                    <b>Total Paid:</b>&nbsp;&nbsp;
                    {{ activity.model.totalPaid | currency }}
                  </td>
                  <td>
                    <a
                      [href]="
                        apiBase +
                        '/files/activityReceipt/' +
                        activity.activityDataId
                      "
                      class="btn btn-raised btn-primary float-right"
                      target="_blank"
                      rel="noopener"
                      *ngIf="
                        activity.model.payments &&
                        activity.model.payments.length > 1
                      "
                    >
                      Full Receipt
                    </a>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </ng-container>
    </div>
          }
          @else{
         <div class="row janus-row" style="margin-left: 0 !important;">
  <div class="col-11 col-md-6 mb-4">
      <div *ngIf="activity.model.totalDue > 0">
        <form *ngIf="manualForm" [formGroup]="manualForm">
  <ng-container *ngIf="showManualPayment">


            <wm-common-dropdown
              [data]="commonDropdownData"
              formControlName="paymentMethod"
              (change)="onPaymentMethodChange($event)"
            ></wm-common-dropdown>



              <wm-common-chip
                *ngIf="activity.model.paymentMethod == '2'"
                  [data]="{
                  label:  'Credit Card POS (Point of Sale) should only be used by
                authorized users to manually record a credit card payment that
                was collected outside of GeoPermits.' ,
                  color: 'error',

                }"
               class="mt-4 w-100"
              >

              </wm-common-chip>

              <div class="form-group">

           <wm-common-textfield
              [data]="{
                label:
                  activity.model.paymentMethod === PaymentMethods.Check
                    ? 'Check #'
                    : activity.model.paymentMethod === PaymentMethods.CreditCardPOS
                    ? 'Confirmation Number'
                    : 'Notes',
                required: activity.model.paymentMethod === PaymentMethods.CreditCardPOS,
                helperText: activity.model.paymentMethod === PaymentMethods.CreditCardPOS
                ? errorFieldMessage(manualForm.controls['transactionNumber'])
                : ''
              }"
              formControlName="transactionNumber"

            >
</wm-common-textfield>


            </div>

              </ng-container>


                <ng-container *ngIf="hasIntegration || showManualPayment">
            <div
              class="form-group"
              *ngIf="activity.model.allowMultiplePayments"
            >
              <div class="row">
                <div class="col-12 mb-2">
                  <wm-common-text
                    [data]="{ text: 'Payment Amount ', required: true }"></wm-common-text>
                  <wm-control-message
                    [control]="manualForm.controls['paymentAmountOption']"
                  ></wm-control-message>
                </div>
              </div>
              <div class="row">
  <div class="col-12 mb-3">
    <wm-common-radio
    class="col-12"
      [data]="{
        options: [
          { label: 'Total Due', value: 'fullAmount' },
          { label: 'Other Amount', value: 'partialAmount' }
        ],
        direction: 'column'
      }"
      formControlName="paymentAmountOption"
    ></wm-common-radio>
  </div>

 <div class="col-12 col-md-8 col-lg-6">

    <div [ngClass]="{'disabledInActiveDiv': paymentOption !== 'fullAmount'}" class="mb-4">
      <wm-common-text
        [data]="{ text: activity.model.totalDue | currency  }"></wm-common-text>

    </div>

    <div [ngClass]="{'disabledInActiveDiv': paymentOption !== 'partialAmount'}">
      <div style="padding-bottom: 20px;">
      <wm-common-textfield
        [data]="{
          label: 'Enter Amount',
          type: 'number',
          required: paymentOption === 'partialAmount',
          helperText: paymentOption === 'partialAmount'
              ? paymentAmountErrorMsg : '',
              value: activity.model.paymentAmount
        }"
        formControlName="paymentAmount"
        (valueChange)="activity.model.paymentAmount = $event"
        ></wm-common-textfield>
      </div>
       <wm-common-text
        [data]="{ text: 'You will not be able to continue past this step in the process until the fees are paid in full.',
        fontSize: '80%',
      }"></wm-common-text>
      <!-- <wm-control-message
        [control]="manualForm.controls['paymentAmount']"
      ></wm-control-message> -->
    </div>

  </div>
</div>
            </div>
            <ng-template #paymentButton>
          <wm-common-button
                [data]="{
                  text: !processing ? 'Make Payment' : 'Loading Payment Form...',
                  variant: 'flat',
                  className: 'button-radius-4 w-80',
                  disabled: processing ||
                            !PaymentMethods[activity.model.paymentMethod] ||
                            viewingAsApplicantInTest,
                  onClick: submitPayment.bind(this)
                }"
              >
              </wm-common-button>
            </ng-template>
            <ng-template #forteCheckoutPaymentButton>
             <wm-common-button
              id="fortePaymentButton"
              [data]="{
                text: processing ? 'Processing Payment' : 'Make Payment',
                variant: 'flat',
                className: 'button-radius-4 w-80',
                disabled: processing ||
                          !PaymentMethods[activity.model.paymentMethod] ||
                          viewingAsApplicantInTest ||
                          signing ||
                          manualForm.invalid
              }"
              callback="callback"
              method="sale"
              version_number="2.0"
              hash_method="sha256"
              [attr.api_access_id]="activity.model.paymentButtonParameters.apiAccessId"
              [attr.total_amount]="activity.model.paymentButtonParameters.amount"
              [attr.location_id]="activity.model.paymentButtonParameters.locationId"
              [attr.utc_time]="activity.model.paymentButtonParameters.utcTime"
              [attr.order_number]="activity.model.paymentButtonParameters.orderNumber"
              [attr.signature]="activity.model.paymentButtonParameters.signature"
            >
            </wm-common-button>
            </ng-template>
            <ng-container
              *ngIf="activity && activity.model && activity.model.paymentButtonTemplate && this[activity.model.paymentButtonTemplate]"
            >
              <ng-template
                *ngTemplateOutlet="(activity.model.paymentMethod == PaymentMethods.Online ? this[activity.model.paymentButtonTemplate] : this['paymentButton']);"
              ></ng-template>
            </ng-container>
          </ng-container>



              </form>





      <div class="mt-2">
          <wm-common-text *ngIf="viewingAsApplicantInTest"
            [data]="{ text: 'Cannot make an online payment in a test application. Please change to an admin role to make a manual payment.', fontFamily: 'roboto', textTransform: 'none' }">
          </wm-common-text>

          <wm-common-text
            *ngIf="isGlobalAdmin && isTestApplication && activity.model.paymentMethod === PaymentMethods.Online"
            [data]="{ text: 'Note: Not all online payment providers are set up to work in a test application.', fontFamily: 'roboto' }">
          </wm-common-text>

          <wm-common-text *ngIf="!hasIntegration && !showManualPayment"
            [data]="{ text: 'Please pay in the office' }">
          </wm-common-text>
        </div>
      </div>
    <div *ngIf="!(activity.model.totalDue > 0)">
  <wm-common-text [data]="{ text: 'No fees due.' }"></wm-common-text>
</div>


    </div>
    <div class="col-12">
     <div class="card">
  <div class="card-body">
    <wm-common-text
      [data]="{ text: 'Fee Summary', fontWeight: 'bold', fontSize: 18 }"
      class="card-title d-block mb-3">
    </wm-common-text>

    <div *ngIf="!lineItems">
      <wm-common-text [data]="{ text: 'Loading Fees', fontStyle: 'italic' }"></wm-common-text>
    </div>

    <ng-container *ngIf="lineItems">
      <ul class="list-unstyled mt-3">
        <li *ngFor="let fee of lineItems" class="my-2 d-flex justify-content-between">
          <wm-common-text [data]="{ text: fee.name }"></wm-common-text>
          <wm-common-text [data]="{ text: (fee.amount | currency) }"></wm-common-text>
        </li>
      </ul>
      <hr />
    </ng-container>

    <ng-container *ngIf="activity.model.fees">
      <div class="d-flex justify-content-between mt-3">
        <wm-common-text [data]="{ text: 'Total Fees' }"></wm-common-text>
        <wm-common-text [data]="{ text: (activity.model.totalFees | currency) }"></wm-common-text>
      </div>
      <hr />
    </ng-container>

    <div class="d-flex justify-content-between mt-4">
      <wm-common-text [data]="{ text: 'Total Due', fontWeight: 'bold', fontSize: 16 }"></wm-common-text>
      <wm-common-text
        [data]="{
          text: (activity.model.totalDue | currency),
          fontWeight: 'bold',
          fontSize: 16
        }">
      </wm-common-text>
    </div>
  </div>
</div>

    </div>
</div>
     <ng-container
        *ngIf="activity.model.payments && activity.model.payments.length > 0"
      >
        <div class="card mt-4" *ngIf="activity.model.payments && activity.model.payments.length > 0">
  <div class="card-body">
    <h6 class="card-title">Payments Made</h6>

    <wm-common-table
      [columns]="paymentTableColumns"
      [data]="data"
      tableClass="table">
    </wm-common-table>

    <div class="text-right mt-3">
      <wm-common-text [data]="{ text: 'Total Paid: ' + (activity.model.totalPaid | currency), fontWeight: 'bold' }">
      </wm-common-text>

      <div class="mt-2" *ngIf="activity.model.payments.length > 1">
        <a [href]="apiBase + '/files/activityReceipt/' + activity.activityDataId"
           class="btn btn-raised btn-primary" target="_blank">
           Full Receipt
        </a>
      </div>
    </div>
  </div>
</div>
      </ng-container>
          }




  </div>
</form>
